import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { succsesDataDeleteAlert } from "../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import moment from "moment/moment";
import { PaginatedItems } from "../../components/pagination/Pagination";
import useDebounse from "../../helpers/useDebounse";
import { useSelector } from "react-redux";

const Clients = () => {
    const permissions = useSelector((state) => state.status.permissions);

    const [clientsList, setClientsList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setSearchValue] = useState("");

    const debounceSearch = useDebounse(searchValue, 1000);

    const searchQwery = "&search=" + debounceSearch;
    const pagination = "&page=" + currentPage;

    const { data: clients, refetch: refetClients } = useGetPageQuery("clients?" + pagination + searchQwery);
    const [deleteClient, { isLoading, isError }] = useSendFormMutation();

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setClientsList([...clientsList, e.target.value]);
        } else if (!e.target.checked) {
            setClientsList([...clientsList.filter((id) => id !== e.target.value)]);
        }
    };

    const deleteClientsHandler = async () => {
        for (const store of clientsList) {
            await deleteClient({ body: {}, url: "clients/" + store, method: "DELETE" });
        }

        if (!isError) {
            succsesDataDeleteAlert();
        }

        await refetClients();
    };

    const checkAllHandler = () => {
        setClientsList(clients.data.map((user) => user.id.toString()));
    };

    useEffect(() => {
        const refetch = async () => {
            refetClients();
        };
        refetch();
    }, [clients]);

    return (
        <>
            {clients && (
                <div className="content">
                    <div className="col-12">
                        <div className="header-container mb-3">
                            <div className="header">
                                <h1>Покупці ({clients.total})</h1>
                            </div>
                            <div className="header-functions d-flex flex-wrap">
                                <div className="float-end mx-2 my-2">
                                    <Link className="btn btn-primary" to={"/client"}>
                                        Додати покупця
                                    </Link>
                                </div>
                                <div className="float-end  mx-2 my-2">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Пошук..."
                                            onChange={(e) => setSearchValue(e.target.value)}
                                        />
                                        <button className="btn btn-outline-secondary" type="button" id="button-addon2">
                                            <i className="bi bi-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a className="check_all" onClick={checkAllHandler}>
                            Виділити все
                        </a>
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th data-field="check"></th>
                                    <th data-field="user_np" style={{ width: "21px" }}></th>
                                    <th data-field="user_name">Ім'я</th>
                                    <th data-field="user_card" className="no-mobile">
                                        Карта клієнта
                                    </th>
                                    <th data-field="user_phone" className="no-mobile">
                                        Телефон
                                    </th>
                                    <th data-field="user_discount">Знижка</th>
                                    <th data-field="user_date" className="no-mobile">
                                        Створено
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {clients.data.map((client) => {
                                    return (
                                        <tr key={client.id}>
                                            <td className="check_area text-right">
                                                <div className="custom-control custom-checkbox">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={clientsList.includes(client.id.toString())}
                                                        value={client.id}
                                                        onChange={(e) => listCheckHandler(e)}
                                                    />
                                                    <label className="custom-control-label" for="check_u59636">
                                                        &nbsp;
                                                    </label>
                                                </div>
                                            </td>
                                            <td className="no-padding-side"></td>
                                            <td>
                                                <Link to={"/client/" + client.id}>{client.name}</Link>
                                                <div className="">{client.phone}</div>
                                            </td>
                                            <td className="no-mobile">{client.card}</td>

                                            <td className="no-mobile">{client.phone}</td>
                                            <td>{client.discount}%</td>
                                            <td className="no-mobile">
                                                {moment(client.created_at).format("DD.MM.YYYY")}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        {permissions.includes("client_edit") || permissions.includes("all") ? (
                            <div className="d-flex">
                                <select name="action" className="form-select" style={{ width: "auto" }}>
                                    <option value="delete">Видалити</option>{" "}
                                </select>
                                <button className="btn btn-info mx-3" onClick={deleteClientsHandler}>
                                    {isLoading ? "Завантаження" : "Виконати"}
                                </button>
                            </div>
                        ) : null}

                        <nav className="mt-3">
                            <PaginatedItems pageCount={clients.last_page} setCurrentPage={setCurrentPage} />
                        </nav>
                    </div>
                </div>
            )}
        </>
    );
};

export default Clients;
